import { MarketingResultDto } from "./marketingResultDto";

export class MarketingCampainDto {
	public id: number = 0;
	public description: string = "";
	public createdAt: Date = new Date();
	public targetLink: string = "";
	public isPermanent: boolean = false;
	public results: MarketingResultDto[] = [];
}
